import { supabase } from "./supabaseClient";

export type DocumentKind = "quote" | "invoice";

export async function setDocumentsArchived(kind: DocumentKind, ids: string[], archived: boolean) {
  const { error } = await supabase.rpc("set_documents_archived", {
    p_kind: kind,
    p_ids: ids,
    p_archived: archived,
  });
  if (error) throw new Error("Impossible de modifier l’archivage. Veuillez réessayer.");
  window.dispatchEvent(new Event("documents-changed"));
}
